import { createContext, useState, useEffect } from "react";

// Sprachdateien
import de from "../i18n/de";
import en from "../i18n/en";
import it from "../i18n/it";
import fr from "../i18n/fr";
import nl from "../i18n/nl";
import es from "../i18n/es";
import hr from "../i18n/hr";

// date-fns Locales
import { de as deLocale } from "date-fns/locale";
import { enGB } from "date-fns/locale";   // 🇬🇧 UK English
import { it as itLocale } from "date-fns/locale";
import { fr as frLocale } from "date-fns/locale";
import { nl as nlLocale } from "date-fns/locale";
import { es as esLocale } from "date-fns/locale";
import { hr as hrLocale } from "date-fns/locale";

export const LanguageContext = createContext();

// Mapping aller Sprachdateien
const languages = { de, en, it, fr, nl, es, hr };

// Mapping der date-fns Locales
const locales = {
  de: deLocale,
  en: enGB,   // 🇬🇧 UK statt US
  it: itLocale,
  fr: frLocale,
  nl: nlLocale,
  es: esLocale,
  hr: hrLocale
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("de");

  // Sprache aus localStorage laden
  useEffect(() => {
    const saved = localStorage.getItem("language");
    if (saved && languages[saved]) {
      setLanguage(saved);
    }
  }, []);

  // Sprache ändern + speichern
  const changeLanguage = (lang) => {
    if (languages[lang]) {
      setLanguage(lang);
      localStorage.setItem("language", lang);
    }
  };

  return (
    <LanguageContext.Provider
      value={{
        language,
        changeLanguage,
        texts: languages[language],
        locale: locales[language]
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
